import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import rootReducer from './store/reducers';
import Routes from './Routes';
import { setSessionStorage, clearSessionStorage } from './helpers/session';
import { GlobalStyle } from './styles/globals';

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;
/* eslint-enable */

const enhancer = composeEnhancers(applyMiddleware(thunk));
const store = createStore(rootReducer, enhancer);

class Module extends Component {
  componentWillMount() {
    if (this.props.moduleData) {
      setSessionStorage(this.props.moduleData);
    }
  }

  componentWillUnmount() {
    clearSessionStorage();
  }

  render() {
    return (
      <Provider store={store}>
        <Fragment>
          <GlobalStyle />
          <Routes />
        </Fragment>
      </Provider>
    );
  }
}

Module.propTypes = {
  moduleData: PropTypes.object,
};

export default Module;



// WEBPACK FOOTER //
// ./src/Module.js